// Monkey-patches window.fetch for demo mode. This single choke point covers the
// app's `fetchApi`/`fetchApiDownload` helpers AND the handful of bare
// `fetch(API_URL + ...)` call sites (auth, getTextSrt, TextDisplay word load).
// Uploads use XHR, but every upload control is hidden in demo mode.
//
// Only same-origin /api (and media) URLs are intercepted; all other requests
// (static assets, the fixtures bundle) fall through to the real fetch.

import { IS_DEMO_RECORD } from './config';
import { isApiUrl } from './signature';
import { handleDemoRequest } from './handler';
import { captureResponse, mountRecorderUi } from './recorder';

function urlOf(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input;
  if (input instanceof URL) return input.toString();
  if (input instanceof Request) return input.url;
  return String(input);
}

function methodOf(input: RequestInfo | URL, init?: RequestInit): string {
  if (init?.method) return init.method;
  if (input instanceof Request) return input.method;
  return 'GET';
}

export function installDemoFetch(): void {
  const originalFetch = window.fetch.bind(window);

  window.fetch = async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const url = urlOf(input);

    if (!isApiUrl(url)) {
      return originalFetch(input, init);
    }

    const method = methodOf(input, init);

    if (IS_DEMO_RECORD) {
      const res = await originalFetch(input, init);
      // Clone so the app still consumes the original stream.
      void captureResponse(method, url, res.clone());
      return res;
    }

    // Replay: answer synchronously from fixtures/overlay.
    return handleDemoRequest(method, url, init);
  };

  if (IS_DEMO_RECORD) mountRecorderUi();
}
